import {
  BookingDate,
  DateType,
  Delimiter,
  ExportFormat,
  FirstDayOfWeek,
  Footer,
  Header,
  JsonObject,
  Language,
  NumberFormatSeparator,
  NumberType,
  PaymentScreenLayout,
  RemoveNoTransactionsPages,
  StatementNumber,
  Tag20,
  Tag28,
  Tag61,
  Tag64,
  Tag65,
  Tag86,
  WithoutTransactions,
} from '../types';

export const delimiter: Delimiter[] = [
  'SETTINGS_EXPORTDELIMITER_OPTION_COMMA',
  'SETTINGS_EXPORTDELIMITER_OPTION_SEMICOLON',
  'SETTINGS_EXPORTDELIMITER_OPTION_TAB',
  'SETTINGS_EXPORTDELIMITER_OPTION_PIPE',
  'SETTINGS_EXPORTDELIMITER_OPTION_EXCLAMATION',
];

export const dateFormatExample: DateType[] = [
  { value: 'AUSTRIA_GERMANY_SWITZERLAND', label: 'DD.MM.YYYY HH:mm:ss' },
  { value: 'FRANCE_SPAIN_UNITED_KINGDOM', label: 'DD/MM/YYYY HH:mm:ss' },
  { value: 'UNITED_STATES', label: 'MM/DD/YYYY HH:mm:ss AM/PM' },
];

export const dateFormat: JsonObject = {
  AUSTRIA_GERMANY_SWITZERLAND: {
    dateFormat: 'DD.MM.YYYY',
    dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
    muiDateFormat: 'dd.MM.yyyy',
  },
  FRANCE_SPAIN_UNITED_KINGDOM: {
    dateFormat: 'DD/MM/YYYY',
    dateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
    muiDateFormat: 'dd/MM/yyyy',
  },
  UNITED_STATES: {
    dateFormat: 'MM/DD/YYYY',
    dateTimeFormat: 'MM/DD/YYYY HH:mm:ss AM/PM',
    muiDateFormat: 'MM/dd/yyyy',
  },
};

export const exportFormat: ExportFormat[] = [
  'SETTINGS_EXPORTFORMAT_OPTION_NONE',
  'SETTINGS_EXPORTFORMAT_OPTION_CSV',
  'SETTINGS_EXPORTFORMAT_OPTION_XLS',
];

export const firstDayOfWeek: FirstDayOfWeek[] = [
  { value: 0, label: 'sunday' },
  { value: 1, label: 'monday' },
];

export const numberFormatExample: NumberType[] = [
  { value: 'COMMA_DOT', label: '12.345.678,90' },
  { value: 'COMMA_SPACE', label: '12 345 678,90' },
  { value: 'DOT_APOSTROPHE', label: "12'345'678.90" },
  { value: 'DOT_COMMA', label: '12,345,678.90' },
];

export const numberFormat: Record<NumberFormatSeparator, { thousandSeparator: string; decimalSeparator: string }> = {
  DOT_COMMA: {
    thousandSeparator: ',',
    decimalSeparator: '.',
  },
  COMMA_DOT: {
    thousandSeparator: '.',
    decimalSeparator: ',',
  },
  DOT_APOSTROPHE: {
    thousandSeparator: "'",
    decimalSeparator: '.',
  },
  COMMA_SPACE: {
    thousandSeparator: ' ',
    decimalSeparator: ',',
  },
};

export const language: Language[] = [
  { value: 'de', label: 'Deutsch' },
  { value: 'en', label: 'English' },
  { value: 'fr', label: 'Français' },
  { value: 'it', label: 'Italiano' },
  { value: 'es', label: 'Español' },
];

export const paymentScreenLayout: PaymentScreenLayout[] = [
  { value: 'DEFAULT_LAYOUT', label: 'Three Columns (Default)' },
  { value: 'OLD_LAYOUT', label: 'Classic Layout' },
  { value: 'TWO_COLUMN_LAYOUT', label: 'Two Columns' },
];

export const removeNoTransactionsPages: RemoveNoTransactionsPages[] = [
  'SETTINGS_DOWNLOAD_PDF_EMPTY_PAGES_OPTION_A',
  'SETTINGS_DOWNLOAD_PDF_EMPTY_PAGES_OPTION_B',
];

export const header: Header[] = [
  'SETTINGS_DOWNLOAD_HEADER_OPTION_A',
  'SETTINGS_DOWNLOAD_HEADER_OPTION_B',
  'SETTINGS_DOWNLOAD_HEADER_OPTION_C',
];

export const footer: Footer[] = ['SETTINGS_DOWNLOAD_MT999_FOOTER_OPTION_A', 'SETTINGS_DOWNLOAD_MT999_FOOTER_OPTION_B'];

export const tag20: Tag20[] = ['SETTINGS_DOWNLOAD_TAG_20_OPTION_A', 'SETTINGS_DOWNLOAD_TAG_20_OPTION_B'];

export const tag28: Tag28[] = ['SETTINGS_DOWNLOAD_TAG_28_OPTION_A', 'SETTINGS_DOWNLOAD_TAG_28_OPTION_B'];

export const tag61: Tag61[] = [
  'SETTINGS_DOWNLOAD_TAG_61_OPTION_A',
  'SETTINGS_DOWNLOAD_TAG_61_OPTION_B',
  'SETTINGS_DOWNLOAD_TAG_61_OPTION_C',
];

export const tag64: Tag64[] = ['SETTINGS_DOWNLOAD_TAG_64_OPTION_A', 'SETTINGS_DOWNLOAD_TAG_64_OPTION_B'];

export const tag65: Tag65[] = ['SETTINGS_DOWNLOAD_TAG_65_OPTION_A', 'SETTINGS_DOWNLOAD_TAG_65_OPTION_B'];

export const tag86: Tag86[] = ['SETTINGS_DOWNLOAD_TAG_86_OPTION_A', 'SETTINGS_DOWNLOAD_TAG_86_OPTION_B'];

export const withoutTransactions: WithoutTransactions[] = [
  'SETTINGS_DOWNLOAD_WITHOUT_TR_OPTION_A',
  'SETTINGS_DOWNLOAD_WITHOUT_TR_OPTION_B',
];

export const statementNumber: StatementNumber[] = [
  'SETTINGS_DOWNLOAD_STATEMENT_NO_OPTION_A',
  'SETTINGS_DOWNLOAD_STATEMENT_NO_OPTION_B',
  'SETTINGS_DOWNLOAD_STATEMENT_NO_OPTION_C',
  'SETTINGS_DOWNLOAD_STATEMENT_NO_OPTION_D',
];

export const bookingDate: BookingDate[] = [
  'SETTINGS_DOWNLOAD_TRANSACTION_BOOKING_DATE_OPTION_A',
  'SETTINGS_DOWNLOAD_TRANSACTION_BOOKING_DATE_OPTION_B',
  'SETTINGS_DOWNLOAD_TRANSACTION_BOOKING_DATE_OPTION_C',
];

export const MAX_ACCOUNTS = 2091;

export const exportDateFormat = 'DDMMYYYY_HHmm';
